import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { LocationService } from 'app/masters/location-master/location.service';

@Component({
  selector: 'app-dashboard-configuration',
  templateUrl: './dashboard-configuration.component.html',
  styleUrls: ['./dashboard-configuration.component.scss']
})
export class DashboardConfigurationComponent implements OnInit {
  webconfigData: any;
  showSpinner = false;
  displayedColumns: string[] = [
    'seqNo',
    'fieldName',
    'isShowOnDashBoard',
    'width',
    'fieldCaption',
    'format',
    'datatype',
    'alignment',
    'edit'
  ];
  constructor(public dialog: MatDialog , public locationService: LocationService) { }

  ngOnInit(): void {
    this.getopdmanagerwebConfig()
  }
  closedialog() {
    this.dialog.closeAll();
  }
  
  getopdmanagerwebConfig(){
    this.showSpinner = true;
    this.locationService
    .GetOPDManagerConfigWeb()
    .subscribe((data: any) => {
      this.webconfigData= data
      this.showSpinner = false;
    });
  }

  editRow(config: any) {
    config.isEditing = true;
  }
  validateNo(e: any): boolean {
    const charCode = e.which ? e.which : e.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false
    }
    return true
  }
  saveRow(config: any) {
    config.isEditing = false;
    console.log('Row updated:', config);
      const SavingPayLoad = {
      "InsertOPDManagerConfigWebDto": {
        "PK_TranID": config.pK_TranID,
        "FK_BranchID": config.fK_BranchID, 
        "FieldName": config.fieldName,
        "FieldCaption": config.fieldCaption,
        "Width": config.width, 
        "SeqNo": config.seqNo,
        "RowNo": config.rowNo, 
        "IsRowLock": config.isRowLock,
        "IsShowOnDashBoard": config.isShowOnDashBoard,
        "IsShow": config.isShow, 
        "Fk_SpecialityId": config.fk_SpecialityId,
        "IsEdit": true
      }
    };
  
    this.locationService.addopdmanagerConfigweb(SavingPayLoad).subscribe(
      (data: any) => {
        if (data.statusCode == 1) {
          this.locationService.openSnackBar("Record Updated successfully", "OK");
        }
      },
      (err) => {
        if (err.status == 403) {
          this.locationService.openSnackBar("You Don't have Permission", "OK");
        } 
        else if(err.error.statusCode == 422){
          this.locationService.openSnackBar(err.error.message,"OK");
        }
        else {
          this.locationService.openSnackBar("API Failed", "OK");
        }
      }
    );
  }
  
  }


